module.exports = __webpack_public_path__ + "Roboto-Medium.fc78759e93a6cac50458.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Medium.woff
// module id = 305
// module chunks = 2